import controller from './churn-retention-dialog.controller';

export default {
  controller,
  template: require('./churn-retention-dialog.html')
};

require('./churn-retention-dialog.less');


// WEBPACK FOOTER //
// src/app/buy/churn-retention-dialog/churn-retention-dialog.component.ts